<template>
  <div>
    <ContentHeader :showBack="true" />
    <div class="content-container" v-loading="loading">
      <div class="task-container">
        <template v-if="taskList.length">
          <div class="task-item" v-for="item in taskList" :key="item.themeDefineId">
            <TaskItem :taskItem="item" :history="true"></TaskItem>
          </div>
        </template>
        <template v-else>
          <div style="width:100%;text-align:center;padding-top:100px">暂无活动配置</div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import tradeApi from '@/api/trade.js'
import ContentHeader from '@/components/content-header'
import TaskItem from '../components/hq-task-item.vue'
export default {
  components: {
    ContentHeader,
    TaskItem
  },
  data () {
    return {
      loading: false,
      taskList: []
    }
  },
  created () {
    this.getThemeDefineHqList()
  },
  methods: {
    // 获取hq活动列表
    getThemeDefineHqList () {
      this.loading = true
      tradeApi.getPerfectHistoryList().then(res => {
        this.loading = false
        if (res.data.resultCode === '0') {
          this.taskList = res.data.resultData.tradePerfectThemeDefineList || []
        }
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.content-container {
  padding: 30px 100px 0;
}
.task-container {
  padding-top: 20px;
  display: flex;
  flex-wrap: wrap;
}
.task-item {
  width: 267px;
  height: 145px;
  margin: 0 32px;
  text-align: center;
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  box-shadow: 0px 0px 16px #eaeaea;
  margin-bottom: 40px;
}
.btn-reset {
  background-color: #bbb;
  color: #ffffff;
}
</style>
